module.exports = __webpack_public_path__ + "img/vona-logo.01ec894e.svg";